import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_nguonkinhphi, Lists_tinhchatnguonkp, tiens_rutdutoan_giaonhanhoso } from '../../../routes/menu'
import { Global, BaoCao } from '../../../shared/global';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import 'jquery'
import 'bootstrap'
import { FileUploader, FileItem, ParsedResponseHeaders } from "ng2-file-upload";
import { SignalrService } from '../../../services/SignalrService'


const swal = require('sweetalert');
@Component({
  selector: 'app-thamsobc-dvckbnnedit',
  templateUrl: './dvckbnnedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./dvckbnnedit.component.scss'],
  providers: [ListService, Repository, SignalrService]
})


export class dvckbnneditComponent implements OnInit {

  uploader: FileUploader;

  thaydoi: boolean = false;
  tabselected: number = 1;
  datas: any=[];
  selectedTab(tab: number) {
    this.tabselected = tab;


  }
  public chons: any = [
    { Id: '1', Ten: "Chi đầu tư" },
    { Id: '2', Ten: "Chi thường xuyên" },
  ];

  public chon2s: any = [
    { Id: '0', Ten: "Tài khoản 3521" },
    { Id: '1', Ten: "Tài khoản 3522" },
    { Id: '2', Ten: "Tài khoản 3523" },
    { Id: '3', Ten: "Tài khoản 3529" },

  ];

  msg: string;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;

  quyen_ktt: boolean = false;
  quyen_ctk: boolean = false;
  quyen_ctk_xoa: boolean = false;

  inputparents: any
  modalTitle: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, MaDonVi: null, TenDonVi: null, DonViId: null, KTT_UserName: null
    , KTT_Password: null, CTK_UserName: null, CTK_Password: null
    , MaCapNS: null, SoTaiKhoanMoTaiKBNN: null, MaKBNN: null, dm_hs_ksc_id: null, TenVietTat: null 
    , v_ma_ho_so: null, v_ma_ho_so_chi_tiet_mau: null, v_tieu_de:null
    , v_tg_ky_so_ktt: null, v_tg_ky_so_ctk: null, Phan_He_Id: null, LoaiMau: null
    , NguoiKy: null, v_tg_gui_dvc: null
    , NguoiKy_KTT: null, NguoiKy_CTK: null, v_du_lieu_toan_van: null
    , v_du_lieu_xac_thuc: null, v_chu_ky_so_ktt: null, v_chu_ky_so_ctk: null, body: null
    , Cer_ktt: null, Cer_ctk: null, hash_xml: null
    , LoaiKy: null, Tich_HienChiTietCacButToan: null, Tich_TenTieuMucLaDienGiai: null
    , DoiTuong: null, Tich_HienThiTungDongChiTiet: null
    , GuiKeToanTruong: null, GuiThuTruong: null, ThongTinBoSung: null, ThamSo: null, TaiKhoan: null
    , Nam: null, ChungTus: null, Created: null, DinhKems: null, FileUrl: null, FileName: null
    , DinhKemId: null, hash_file: null, Cer_ctk_file: null, sign_file: null
    , Temp_FilePath: null, ID_VitriKy: null, sh_base64: null, hash: null
  };
  nhomdtid: string = null;
  hoatdong: string = null;


  @ViewChild('modalthamsogiayrutdutoan02a', { static: false }) modalthamsogiayrutdutoan02a: ModalComponent;
  @ViewChild('dtthamsogiayrutdutoan02aedit', { static: false }) dtthamsogiayrutdutoan02aedit: any;
  @ViewChild('modalthamsogiayrutdutoan02b', { static: false }) modalthamsogiayrutdutoan02b: ModalComponent;
  @ViewChild('dtthamsogiayrutdutoan02bedit', { static: false }) dtthamsogiayrutdutoan02bedit: any;
  @ViewChild('modalthamsobangkethanhtoan_tt39', { static: false }) modalthamsobangkethanhtoan_tt39: ModalComponent;
  @ViewChild('dtbangkethanhtoan_tt39edit', { static: false }) dtbangkethanhtoan_tt39edit: any;
  @ViewChild('modalthamsogiayrutvondautu16b1', { static: false }) modalthamsogiayrutvondautu16b1: ModalComponent;
  @ViewChild('dtthamsogiayrutvondautu16b1edit', { static: false }) dtthamsogiayrutvondautu16b1edit: any;
  @ViewChild('modalthamsogiaydenghithanhtoan', { static: false }) modalthamsogiaydenghithanhtoan: ModalComponent;
  @ViewChild('dtgiaydenghithanhtoanedit', { static: false }) dtgiaydenghithanhtoanedit: any;

  @ViewChild('modalthamsogiaydenghirutvondautu_mau11', { static: false }) modalthamsogiaydenghirutvondautu_mau11: ModalComponent;
  @ViewChild('dtthamsogiaydenghirutvondautu_mau11edit', { static: false }) dtthamsogiaydenghirutvondautu_mau11edit: any;

  //@ViewChild('modalthamso_giaydenghithanhtoanc37hd', { static: false }) modalthamso_giaydenghithanhtoanc37hd: ModalComponent;
  //@ViewChild('dtgiaydenghithanhtoanc37hdedit', { static: false }) dtgiaydenghithanhtoanc37hdedit: any;

  @ViewChild('modalthamso_uynhiemchi_c4_02a', { static: false }) modalthamso_uynhiemchi_c4_02a: ModalComponent;
  @ViewChild('dtuynhiemchi_c4_02aedit', { static: false }) dtuynhiemchi_c4_02aedit: any;

  @ViewChild('modalthamso_uynhiemchi_c4_02c', { static: false }) modalthamso_uynhiemchi_c4_02c: ModalComponent;
  @ViewChild('dtuynhiemchi_c4_02cedit', { static: false }) dtuynhiemchi_c4_02cedit: any;
  @ViewChild('modalthamso_giaynoptrakinhphi', { static: false }) modalthamso_giaynoptrakinhphi: ModalComponent;
  @ViewChild('dtgiaynoptrakinhphiedit', { static: false }) dtgiaynoptrakinhphiedit: any;


  @ViewChild('modal', { static: false }) modal: ModalComponent;
  @ViewChild('dteChung', { static: false }) doituongchungedit: any;
  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('modaltuychinhmaubc', { static: false }) modaltuychinhmaubc: ModalComponent;
  @ViewChild('dtsuamaubaocao', { static: false }) dtsuamaubaocao: any;
  @Output() save: EventEmitter<any> = new EventEmitter();

  LoaiMau: any;
  cer_nguoiky: any;
  rowfile: any;

  constructor(private _dataService: ListService, private repo: Repository, private _signalRService: SignalrService) {

    
    // đăng ký để lấy kết quả trả về từ server
    //dựa trên đăng ký this.proxy.on('send_cer_web' trong SignalrService
    this._signalRService.cerReceived.subscribe((cer: any) => {
      //console.log("cerReceived - taitai");
      //console.log(cer);
      if (this.cer_nguoiky==0)
        this.doituongSelect.Cer_ktt = cer;
      if (this.cer_nguoiky == 1)
        this.doituongSelect.Cer_ctk = cer;
      if (this.cer_nguoiky == 10)
        this.doituongSelect.Cer_ctk_file = cer;

      $('#loading').show();
      this.doituongSelect.LoaiKy = this.cer_nguoiky;

      if (this.cer_nguoiky == 10) {
        this.repo.postRequest("api/dvcapi/KySo_FILE_HASH/", this.doituongSelect)
          .subscribe(response => {
            $('#loading').hide();
            if (response.TrangThai == "OK") {
              this.doituongSelect.ID_VitriKy = response.ID_VitriKy;
              this.doituongSelect.Temp_FilePath = response.Temp_FilePath;
              this.doituongSelect.sh_base64 = response.sh_base64;
              this.doituongSelect.hash = response.hash;
              //console.log("cerReceived - duong dan");
              //console.log(response.duongdan);
              // sau khi lấy được cer thì gọi về server lấy chuỗi hash xml để thực hiện ký số
              this._signalRService.proxy.invoke("request_sign_web", 'eDMS2020', response.sh_base64);

            }
            else
              swal('Cảnh báo!', response.TrangThai, 'warning');
          });
      }
      else {
        this.repo.postRequest("api/dvcapi/KySo_DVC_HASH/", this.doituongSelect)
          .subscribe(response => {
            $('#loading').hide();
            if (response.TrangThai == "OK") {
              //console.log("cerReceived - duong dan");
              //console.log(response.duongdan);
              // sau khi lấy được cer thì gọi về server lấy chuỗi hash xml để thực hiện ký số
              this._signalRService.proxy.invoke("request_sign_web", 'eDMS2020', response.DuongDan);

            }
            else
              swal('Cảnh báo!', response.TrangThai, 'warning');
          });
      }

      
      //console.log(cer);
    });

    this._signalRService.send_signatureReceived.subscribe((signature: any) => {
      //console.log("send_signatureReceived - taitai");
      //console.log(signature);

        if (this.cer_nguoiky == 0)
          this.doituongSelect.v_chu_ky_so_ktt = signature;
      if (this.cer_nguoiky == 1)
        this.doituongSelect.v_chu_ky_so_ctk = signature;
      if (this.cer_nguoiky == 10)
        this.doituongSelect.sign_file = signature;
      if (this.cer_nguoiky == 10) {
        this.repo.postRequest("api/dvcapi/Luu_KySo_FILE_HASH/", this.doituongSelect)
          .subscribe(response => {
            $('#loading').hide();
            if (response.TrangThai == "OK") {
              swal('Thông báo!', "Ký số thành công", 'success');
              //this.LoadData();
              this.repo.getRequest('api/dvcapi/getdinhkem/', { id: this.doituongSelect.Id, chucnang: null }).subscribe(
                data => {
                  this.doituongSelect.DinhKems = data;
                },
                error => {
                }
              );

            }
            else
              swal('Cảnh báo!', response.TrangThai, 'warning');
          });
      }
      else {
        this.repo.postRequest("api/dvcapi/Luu_KySo_DVC_HASH/", this.doituongSelect)
          .subscribe(response => {
            $('#loading').hide();
            if (response.TrangThai == "OK") {
              swal('Thông báo!', "Ký số thành công", 'success');
              this.LoadData();
            }
            else
              swal('Cảnh báo!', response.TrangThai, 'warning');
          });
         }

      
    });

    this._signalRService.send_error_webReceived.subscribe((cer: any) => {
      //console.log("send_error_webReceived - taitai");
      //console.log(cer);
      swal('Cảnh báo!', cer, 'warning');
      //console.log(cer);
    });

  } 

  ngOnInit(): void {
    this.uploader = new FileUploader({
      url: 'api/dvcapi/uploadimage/',
      removeAfterUpload: true,
    });

  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  currentUser: any;

  loadDataInit(doituong: any, donviid: string) {
    this.thaydoi = false;
    this.datas = [];
     //loaiphieu=1 giấy rút mẫu 02
    //loaiphieu=2 giấy rút mẫu 02b
    //loaiphieu=3 giấy rút mẫu 16c1
    //loaiphieu=4 giấy rút mẫu 16c3
    //loaiphieu=5 bảng kê thanh toán mẫu 07 M01
    //loaiphieu=6 giấy đề nghị thanh toán mẫu 05A
    //loaiphieu=7 giấy nộp trả kinh phí mẫu 06

   

    //this.LoaiMau = loaiphieu;
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.id === tiens_rutdutoan_giaonhanhoso.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        this.modalTitle = giatri[0].ten_Phan_He;
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }

      giatri = data.ds_quyen.filter(name => name.id === ("22D9C33F-7926-40AE-BCD2-EA489EF0E373").toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].them == true)
          this.quyen_ktt = true;
        else
          this.quyen_ktt = false;
        
      }

      giatri = data.ds_quyen.filter(name => name.id === ("251A454C-B0FE-461A-AE37-55441381AACB").toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].them == true)
          this.quyen_ctk = true;
        else
          this.quyen_ctk = false;


        if (giatri[0].xoa == true)
          this.quyen_ctk_xoa = true;
        else
          this.quyen_ctk_xoa = false;

        

      }


    }

    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);
    //this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/null/' + donviid)
    //  .subscribe(response => {
    //    this.inputparents = response;
    //  });
    this.doituongSelect = {
      Id: null, MaDonVi: null, TenDonVi: null, DonViId: null, KTT_UserName: null
      , KTT_Password: null, CTK_UserName: null, CTK_Password: null
      , MaCapNS: null, SoTaiKhoanMoTaiKBNN: null, MaKBNN: null, dm_hs_ksc_id: null, TenVietTat: null 
      , v_ma_ho_so: null, v_ma_ho_so_chi_tiet_mau: null, v_tieu_de: null
      , v_tg_ky_so_ktt: null, v_tg_ky_so_ctk: null, Phan_He_Id: null, LoaiMau: null
      , NguoiKy: null, v_tg_gui_dvc: null
      , NguoiKy_KTT: null, NguoiKy_CTK: null, v_du_lieu_toan_van: null
      , v_du_lieu_xac_thuc: null, v_chu_ky_so_ktt: null, v_chu_ky_so_ctk: null, body: null
      , Cer_ktt: null, Cer_ctk: null
      //, hash_file: null
      , LoaiKy: null, Tich_HienChiTietCacButToan: null, Tich_TenTieuMucLaDienGiai: null
      , DoiTuong: null, Tich_HienThiTungDongChiTiet: null
      , GuiKeToanTruong: null, GuiThuTruong: null, ThongTinBoSung: null, ThamSo: null, TaiKhoan: null
      , Nam: null, ChungTus: null, Created: null, DinhKems: null, FileUrl: null, FileName: null
      , DinhKemId: null, hash_file: null, Cer_ctk_file: null, sign_file: null
      , Temp_FilePath: null, ID_VitriKy: null, sh_base64: null, hash: null
    };
    this.doituongSelect.Nam = this.currentUser.nam_ke_toan;

    if (doituong != null) {
      this.doituongSelect.Id = doituong.Id;
      this.doituongSelect.DonViId = donviid;
      this.repo.getRequest('api/dvcapi/getdinhkem/', { id: this.doituongSelect.Id, chucnang: null }).subscribe(
        data => {
          this.doituongSelect.DinhKems = data;
        },
        error => {
        }
      );
     }
    else {
      this.doituongSelect.DonViId = donviid;
      this.doituongSelect.DinhKems = [];
    }
     
    this.LoadData();
    
   


    //this.doituongSelect.Tich_HienChiTietCacButToan = true;
    

  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  } 
  public LoadData() { 
    //let data = {
    //  Id: this.doituongSelect.Id,
    //  Type: null,
    //  Data: JSON.stringify(this.doituongSelect)
    //};
    this.repo.postRequest("api/dvcapi/getbyid_dvc", this.doituongSelect)
      .subscribe(response => { 
        this.doituongSelect.KTT_UserName = response.KTT_UserName;
        this.doituongSelect.KTT_Password = response.KTT_Password;
        this.doituongSelect.CTK_UserName = response.CTK_UserName;
        this.doituongSelect.CTK_Password = response.CTK_Password;

        this.doituongSelect.MaCapNS = response.MaCapNS;
        this.doituongSelect.SoTaiKhoanMoTaiKBNN = response.SoTaiKhoanMoTaiKBNN;
        this.doituongSelect.MaKBNN = response.MaKBNN;
        this.doituongSelect.dm_hs_ksc_id = response.dm_hs_ksc_id;
        this.doituongSelect.MaDonVi = response.MaDonVi;
        this.doituongSelect.TenDonVi = response.TenDonVi;
        this.doituongSelect.TenVietTat = response.TenVietTat;

        this.doituongSelect.v_ma_ho_so = response.v_ma_ho_so;
        this.doituongSelect.v_ma_ho_so_chi_tiet_mau = response.v_ma_ho_so_chi_tiet_mau;
        this.doituongSelect.v_tieu_de = response.v_tieu_de;

        this.doituongSelect.GuiKeToanTruong = response.GuiKeToanTruong;
        this.doituongSelect.GuiThuTruong = response.GuiThuTruong;
        this.doituongSelect.TaiKhoan = response.TaiKhoan;

        if (response.v_tg_ky_so_ktt != null)
          this.doituongSelect.v_tg_ky_so_ktt = new Date(response.v_tg_ky_so_ktt);
        if (response.v_tg_ky_so_ctk != null)
          this.doituongSelect.v_tg_ky_so_ctk = new Date(response.v_tg_ky_so_ctk);
        if (response.v_tg_gui_dvc != null)
          this.doituongSelect.v_tg_gui_dvc = new Date(response.v_tg_gui_dvc);

        if (response.Created != null)
          this.doituongSelect.Created = new Date(response.Created);

        this.datas = response.ChungTus;
        

        

       
        //if (response.v_tg_gui_dvc != null) {
        //  this.repo.postRequest("api/dvcapi/CheckDocumentStatus/", this.doituongSelect)
        //    .subscribe(response => {

        //    });
        //}


        //this.doituongSelect.MaDonVi = "ZZZZZZ2";
        //this.doituongSelect.KTT_UserName = "8888phammaiphuong";
        //this.doituongSelect.KTT_Password = "Admin@123";
        //this.doituongSelect.CTK_UserName = "8888lenguyenthuanh";
        //this.doituongSelect.CTK_Password = "Admin@123";

        //this.doituongSelect.v_ma_ho_so = "H22_ZZZZZZ2_888800002";
        //this.doituongSelect.v_ma_ho_so_chi_tiet_mau = "220707_ZZZZZZ2_8888002";
      });

    //this.repo.getRequest("api/dvcapi/getbyid_dvc/" + this.doituongSelect.Id + "/" + this.doituongSelect.LoaiMau)
    //  .subscribe(response => {
       

    //  }); 

  }
  public closeModal() {
    this.save.emit(null);
  }
  //public saveproduct() {

  //  this.repo.postRequest("api/doituong/addorupdate", this.doituongSelect)
  //    .subscribe(response => {
  //      console.log(response);
  //      this.doituongSelect.Id = response;
  //      this.save.emit(this.doituongSelect);
  //    });

  //} 
  public tuychinhmaubaocao() {
    this.dtsuamaubaocao.loadDataInit(BaoCao.BC06_GiayRutDuToan_02a);
    this.modaltuychinhmaubc.open();
  }
  public xoangayguidvc() {

    swal({
      title: 'Bạn muốn xóa ngày gửi dịch vụ công phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.thaydoi = true;
          this.doituongSelect.ChungTus = this.datas;
          this.repo.postRequest("api/dvcapi/addorupdate_xoangayguidvc", this.doituongSelect)
            .subscribe(response => {
              //this.LoadData();
              if (response.Status == "OK") {
                swal('Thông báo!', "Hoàn thành", 'success');
                this.thaydoi = false;
              }
              else
                swal('Cảnh báo!', response.Status, 'warning');
            });
        }
      });


    
  }
  public savepheduyet() {
    this.doituongSelect.GuiKeToanTruong = 1;
    this.savedt(1); 
  }
  public savedt(loai: number) {

    //console.log("ttt_hhh");
    //console.log(this.doituongSelect);
    this.thaydoi = true;
    this.doituongSelect.ChungTus = this.datas;
    this.repo.postRequest("api/dvcapi/addorupdate", this.doituongSelect)
      .subscribe(response => {
        //this.LoadData();
        if (loai == 1) {
          if (response.Status == "OK") {
            swal('Thông báo!', "Đã gửi Kế toán trưởng phê duyệt", 'success');

            this.thaydoi = false;
          }
          else
            swal('Cảnh báo!', response.Status, 'warning');
        }
        else {
          if (response.Status == "OK") {
            this.doituongSelect.Id = response.Data.Id;
            swal('Thông báo!', "Hoàn thành", 'success');
            this.thaydoi = false;
          }
          else
            swal('Cảnh báo!', response.Status, 'warning');
        }
      });
  }
  public savethaydoi() {
    this.thaydoi = true;
  }
  public savets(loai: number) {

    //console.log("ttt_hhh");
    //console.log(this.doituongSelect);

    //this.repo.postRequest("api/dvcapi/addorupdate", this.doituongSelect)
    //  .subscribe(response => {
    //    this.LoadData();
    //    if (loai == 1) {
    //      swal('Thông báo!', "Đã gửi Kế toán trưởng phê duyệt", 'success');
    //    }
    //  });
  }
  public export(kieuin) {
    $('#loading').show();
    let data = {
      Id: BaoCao.BC06_GiayRutDuToan_02a, // id cứng trong FunctionConstants để điều hướng đến hàm giay rút dự toán
      Type: kieuin,
      Data: JSON.stringify(this.doituongSelect)
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          $('#loading').hide();
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "giayrutdutoanc2-02a.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            $('#loading').hide();
            //this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
            //  data => {
            //    $('#loading').hide();
            //  },
            //  error => {
            //    this.msg = error;
            //  }
            //);
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }
    


  }

  Gui_DVC() {

    if (this.doituongSelect.MaDonVi == null || this.doituongSelect.MaDonVi == "") {
      swal('Cảnh báo!', "Mã quan hệ ngân sách không được trống", 'warning');
      return;
    }
    if (this.doituongSelect.TenDonVi == null || this.doituongSelect.TenDonVi == "") {
      swal('Cảnh báo!', "Tên đơn vị không được trống", 'warning');
      return;
    }
    if (this.doituongSelect.TenVietTat == null || this.doituongSelect.TenVietTat == "") {
      swal('Cảnh báo!', "Tên viết tắt của đơn vị không được trống", 'warning');
      return;
    }

    if (this.doituongSelect.v_ma_ho_so == null || this.doituongSelect.v_ma_ho_so == "" ) {
      swal('Cảnh báo!', "Mã hồ sơ không được trống", 'warning');
      return;
    }

    if (this.doituongSelect.v_tieu_de == null || this.doituongSelect.v_tieu_de == "") {
      swal('Cảnh báo!', "Thông tin tiêu đề không được trống", 'warning');
      return;
    }
    //if (this.doituongSelect.v_ma_ho_so_chi_tiet_mau == null || this.doituongSelect.v_ma_ho_so_chi_tiet_mau == "") {
    //  swal('Cảnh báo!', "Số chứng từ điện tử DVC không được trống", 'warning');
    //  return;
    //}

    if (this.doituongSelect.MaCapNS == null || this.doituongSelect.MaCapNS == "") {
      swal('Cảnh báo!', "Mã cấp ngân sách không được trống", 'warning');
      return;
    }
    if (this.doituongSelect.SoTaiKhoanMoTaiKBNN == null || this.doituongSelect.SoTaiKhoanMoTaiKBNN == "") {
      swal('Cảnh báo!', "Số tài khoản mở tại kho bạc không được trống", 'warning');
      return;
    }

    if (this.doituongSelect.MaKBNN == null || this.doituongSelect.MaKBNN == "") {
      swal('Cảnh báo!', "Mã kho bạc không được trống", 'warning');
      return;
    }

    //if (this.doituongSelect.LoaiMau == 7) {
    //  if (this.doituongSelect.TaiKhoan == null || this.doituongSelect.TaiKhoan == "") {
    //    swal('Cảnh báo!', "Tài khoản không được trống", 'warning');
    //    return;
    //  }
    //}

    //if (this.doituongSelect.dm_hs_ksc_id != null) {
    //  swal('Cảnh báo!', "Mã loại hồ sơ không được trống", 'warning');
    //  return;
    //}


    $('#loading').show();
    this.repo.postRequest("api/dvcapi/Gui_DVC/", this.doituongSelect)
      .subscribe(response => {
        $('#loading').hide();
        if (response.TrangThai == "OK") {
          swal('Thông báo!', "Gửi lên DVC thành công", 'success');
          this.LoadData();
        }
        else
          swal('Cảnh báo!', response.TrangThai, 'warning');
      });
  }
  KySo_file(nguoiky: any, dinhkem: any) {
    this.doituongSelect.DinhKemId = dinhkem.Id;
    this.KySo_DVC(nguoiky);
  }
  KySo_DVC(nguoiky: any) {

    if (this.doituongSelect.MaDonVi == null || this.doituongSelect.MaDonVi == "") {
      swal('Cảnh báo!', "Mã quan hệ ngân sách không được trống", 'warning');
      return;
    }
    if (this.doituongSelect.TenDonVi == null || this.doituongSelect.TenDonVi == "") {
      swal('Cảnh báo!', "Tên đơn vị không được trống", 'warning');
      return;
    }
    if (this.doituongSelect.TenVietTat == null || this.doituongSelect.TenVietTat == "") {
      swal('Cảnh báo!', "Tên viết tắt của đơn vị không được trống", 'warning');
      return;
    }

    if (this.doituongSelect.v_ma_ho_so == null || this.doituongSelect.v_ma_ho_so == "") {
      swal('Cảnh báo!', "Mã hồ sơ không được trống", 'warning');
      return;
    }

    if (this.doituongSelect.v_tieu_de == null || this.doituongSelect.v_tieu_de == "") {
      swal('Cảnh báo!', "Thông tin tiêu đề không được trống", 'warning');
      return;
    }
    //if (this.doituongSelect.v_ma_ho_so_chi_tiet_mau == null || this.doituongSelect.v_ma_ho_so_chi_tiet_mau == "") {
    //  swal('Cảnh báo!', "Số chứng từ điện tử DVC không được trống", 'warning');
    //  return;
    //}

    if (this.doituongSelect.MaCapNS == null || this.doituongSelect.MaCapNS == "") {
      swal('Cảnh báo!', "Mã cấp ngân sách không được trống", 'warning');
      return;
    }
    if (this.doituongSelect.SoTaiKhoanMoTaiKBNN == null || this.doituongSelect.SoTaiKhoanMoTaiKBNN == "") {
      swal('Cảnh báo!', "Số tài khoản mở tại kho bạc không được trống", 'warning');
      return;
    }

    if (this.doituongSelect.MaKBNN == null || this.doituongSelect.MaKBNN == "") {
      swal('Cảnh báo!', "Mã kho bạc không được trống", 'warning');
      return;
    }

    //if (this.doituongSelect.LoaiMau == 7) {
    //  if (this.doituongSelect.TaiKhoan == null || this.doituongSelect.TaiKhoan == "") {
    //    swal('Cảnh báo!', "Tài khoản không được trống", 'warning');
    //    return;
    //  }
    //}


    if (nguoiky == 0) {
      if (this.doituongSelect.KTT_UserName == null || this.doituongSelect.KTT_UserName == "") {
        swal('Cảnh báo!', "tên đăng nhập KTT không được trống", 'warning');
        return;
      }
      if (this.doituongSelect.KTT_Password == null || this.doituongSelect.KTT_Password == "") {
        swal('Cảnh báo!', "Mật khẩu của KTT không được trống", 'warning');
        return;
      }
    }
    else {
      if (this.doituongSelect.CTK_UserName == null || this.doituongSelect.CTK_UserName == "") {
        swal('Cảnh báo!', "tên đăng nhập CTK không được trống", 'warning');
        return;
      }
      if (this.doituongSelect.CTK_Password == null || this.doituongSelect.CTK_Password == "") {
        swal('Cảnh báo!', "Mật khẩu của CTK không được trống", 'warning');
        return;
      }
    }

    if (this.doituongSelect.v_tg_gui_dvc != null) {
      swal('Cảnh báo!', "Không thể thực hiện ký số do đã gửi hồ sơ lên DVC", 'warning');
      return;
    }

    this.cer_nguoiky = nguoiky;
    this.doituongSelect.LoaiKy = nguoiky;
    // nguoiky =0 là kế toán trưởng
    // nguoiky=1 là chủ tài khoản
    // nguoiky=10 ctk ký file
    
    //$('#loading').show();
    //this.doituongSelect.LoaiKy = nguoiky;

    //this.repo.postRequest("api/dvcapi/KySo_DVC/", this.doituongSelect)
    //  .subscribe(response => {
    //    $('#loading').hide();
    //    if (response.TrangThai ==  "OK") {
    //      //location.href = "/Logs/Reports/" + response.DuongDan;
    //      swal('Thông báo!', "Ký số thành công", 'success');
    //      this.LoadData();
    //    }
    //    else
    //      swal('Cảnh báo!', response.TrangThai, 'warning');
    //  });



    // ký qua signService

    // call function request_cer_web từ server
    this._signalRService.startConnection();
    this._signalRService.proxy.invoke("request_cer_web",'');

  }

  adddata() {

    this.modalTitle = "Thêm mới đối tượng";
    this.doituongchungedit.loadDataInit(tiens_rutdutoan_giaonhanhoso.id, null, this.doituongSelect.DonViId);

    this.modal.open();
  }


  editdata(row: any) {
    console.log(row);
    this.modalTitle = "cập nhập thông tin đối tượng";
    this.doituongchungedit.loadDataInit(tiens_rutdutoan_giaonhanhoso.id, row, this.doituongSelect.DonViId);
    this.modal.open();
  }
  saveModal(doituong: any) {
    //console.log("saveModal: danh sách");
    //console.log(doituong);
    if (doituong != null) {
      this.thaydoi = true;
      let tontai = 0;
      this.datas.forEach(
        (item) => {  
          if (item.Chung_Tu_Id.toString() === doituong.Chung_Tu_Id.toString() && item.LoaiMau.toString() === doituong.LoaiMau.toString()) {
            tontai = 1;
            item.Ma_Chung_Tu = doituong.Ma_Chung_Tu;
            item.TaiKhoan = doituong.TaiKhoan;
            item.Tong_Tien = doituong.Tong_Tien;
            item.LoaiMau = doituong.LoaiMau;
            item.LoaiMauS = doituong.LoaiMauS;
          }
        }
      );
      if (tontai==0)
        this.datas.push(doituong);


      console.log(this.datas);
      //let row = this.datas.filter(name => name["Chung_Tu_Id"].toString() === doituong.Chung_Tu_Id.toString() && name["LoaiMau"].toString() === doituong.LoaiMau.toString());
      //if (row == null)
      //  this.datas.push(doituong);
      //else {
      //  row.Ma_Chung_Tu = doituong.Ma_Chung_Tu;
      //  row.TaiKhoan = doituong.TaiKhoan;
      //}



    }
    this.modal.dismiss();
  }



  deleterow(index: string) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          //this.doituongSelect.ChiTiets.splice(index, 1);
          this.datas.splice(index, 1);
        }
      });


  }

  save02a(doituong: any) {
    this.modalthamsogiayrutdutoan02a.dismiss();
    this.modalthamsogiayrutdutoan02b.dismiss();
    this.modalthamsogiayrutvondautu16b1.dismiss();
    this.modalthamsogiaydenghirutvondautu_mau11.dismiss();
  }
  giayrutdutoan02a(row: any) {
    if (row == null || row == "") {
      swal('Cảnh báo!', 'Chưa chọn chứng từ để in!.', 'warning');
      return;
    }
    this.dtthamsogiayrutdutoan02aedit.loadDataInit(row.Chung_Tu_Id, this.currentUser.id_don_vi);
    this.modalthamsogiayrutdutoan02a.open();
  }
  giayrutdutoan02b(row: any) {
    
    this.dtthamsogiayrutdutoan02bedit.loadDataInit(row.Chung_Tu_Id, this.currentUser.id_don_vi);
    this.modalthamsogiayrutdutoan02b.open();
  }
  giaydenghirutvondautu_mau11(loaigiaydenghi: number, row: any) {

    // loaigiaydenghi =0 hoac null: là giấy rút vốn đầu tư mẫu 11
    // loaigiaydenghi=1 là giấy đề nghị thanh toán vốn đầu tư 04a/TT


   
    this.dtthamsogiaydenghirutvondautu_mau11edit.loadDataInit(row.Chung_Tu_Id, this.currentUser.id_don_vi, loaigiaydenghi);
    this.modalthamsogiaydenghirutvondautu_mau11.open();
  }
  giayrutvondautu(loaigiaydenghi: number, row: any) {

    // loaigiaydenghi =0 hoac null: là mẫu giấy rút 16b1
    // loaigiaydenghi=1 là giấy đề nghị thanh toán vốn đầu tư 05/TT
    
    this.dtthamsogiayrutvondautu16b1edit.loadDataInit(row.Chung_Tu_Id, this.currentUser.id_don_vi, loaigiaydenghi);
    this.modalthamsogiayrutvondautu16b1.open();
  }

  saveuynhiemchi_c4_02a(doituong: any) {
    this.modalthamso_uynhiemchi_c4_02a.dismiss();
  }
  uynhiemchi_c4_02a(row: any) {
    this.dtuynhiemchi_c4_02aedit.loadDataInit(row.Chung_Tu_Id, this.currentUser.id_don_vi);
    this.modalthamso_uynhiemchi_c4_02a.open();
  }
  saveuynhiemchi_c4_02c(doituong: any) {
    this.modalthamso_uynhiemchi_c4_02c.dismiss();
  }
  uynhiemchi_c4_02c(row: any) {
    
    this.dtuynhiemchi_c4_02cedit.loadDataInit(row.Chung_Tu_Id, this.currentUser.id_don_vi);
    this.modalthamso_uynhiemchi_c4_02c.open();
  }
  savegiaynoptrakinhphi(doituong: any) {
    this.modalthamso_giaynoptrakinhphi.dismiss();
  }

  giaynoptrakinhphi(row: any) {
    
    this.dtgiaynoptrakinhphiedit.loadDataInit(row.Chung_Tu_Id, this.currentUser.id_don_vi);
    this.modalthamso_giaynoptrakinhphi.open();
  }

  savebangkethanhtoan(doituong: any) {
    this.modalthamsobangkethanhtoan_tt39.dismiss();
  }
  bangkethanhtoan_tt39(row: any) {
   
    this.dtbangkethanhtoan_tt39edit.loadDataInit(row.Chung_Tu_Id, this.currentUser.id_don_vi);
    this.modalthamsobangkethanhtoan_tt39.open();
  }

  savegiaydenghithanhtoan(doituong: any) {
    this.modalthamsogiaydenghithanhtoan.dismiss();
  }
  giaydenghithanhtoan(loaimau: number, row: any) {
   

    if (loaimau == null)
      loaimau = 2;

    //loaimau =1 giấy đề nghị thanh toán
    // loaimau=2 giấy đề nghị thanh toán mẫu 5c
    // loaimau=3 giấy đề nghị thu hồi vốn 04b/TT


    this.dtgiaydenghithanhtoanedit.loadDataInit(row.Chung_Tu_Id, this.currentUser.id_don_vi, loaimau);
    this.modalthamsogiaydenghithanhtoan.open();
  }
  pheduyetds(row: any) {
    let chungtu = null;

    if (row.LoaiMau == 1)
      this.giayrutdutoan02a(row);
    if (row.LoaiMau == 2)
      this.giayrutdutoan02b(row);
    if (row.LoaiMau == 3)
      this.uynhiemchi_c4_02a(row);
    if (row.LoaiMau == 4)
      this.uynhiemchi_c4_02c(row);
    if (row.LoaiMau == 5)
      this.bangkethanhtoan_tt39(row);
    if (row.LoaiMau == 6)
      this.giaydenghithanhtoan(1, row);
    if (row.LoaiMau == 7)
      this.giaynoptrakinhphi(row);

   
  }

  openFile(fileInput: any) {
    console.log('hell');
    fileInput.click();
  }

  onFileSelected(picId: HTMLImageElement) {
    this.uploader.uploadAll();
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);

    //this.uploader.queue[0].onSuccess = function (response, status, headers) {
    //  if (status == 200) {
    //    let abc = JSON.parse(response);
    //    console.log(abc);
    //    picId.textContent = abc.FileName;
    //    picId.parentElement.setAttribute('href', abc.FileUrl);
    //    picId.parentElement.setAttribute('style', 'display:block;padding-top:5px;');
    //    //this.bonhiemSelect.FileName = abc.FileName;
    //    //this.bonhiemSelect.FileUrl = abc.FileUrl;
    //  }
    //};
    this.uploader.queue[0].upload();
  }
  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {

    if (status == 200) {
      let data = JSON.parse(response);
      console.log(data);

      this.doituongSelect.DinhKems.push(data);
      this.thaydoi = true;
    }
  }
  onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let error = JSON.parse(response); //error server response
  }
  removeattch(index: string) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa tệp này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {

          this.doituongSelect.DinhKems.splice(index, 1);
          this.thaydoi = true;
        }
      });


  }




}
